<template>
  <div>
    <v-container fluid grid-list-md  v-if="showGoodByeImage">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="goodbye-title">You are now being redirected to our partner’s page.</div>
        </v-flex>
        <v-flex xs12>
          <v-img
            alt=''
            :src='images["GoodBye"]'
            height='600px'
            contain />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GoodBye from '@/assets/offers/GoodBye.png';

export default {
  name: 'Bellhop',
  data() {
    return {
      images: {
        GoodBye,
      },
      showGoodByeImage: true,
    };
  },
  props: {
  },
  async mounted() {
    setTimeout(() => {
      this.showGoodByeImage = false;
      window.location.href = 'https://www.getbellhops.com/?utm_source=homeguage&utm_medium=affiliate&utm_content=paid:partnerships:affiliate:homeservices:na:na:na&pc=HOMEGUAGE5&utm_campaign=na';
    }, 2000);
  },
  methods: {
  },
};
</script>

<style lang='scss' scoped>
.goodbye-title {
  font-size: 24px;
}
</style>
